import React, { useState } from 'react';
import type { MouseEvent } from 'react';
import { IconButton, Menu, Tooltip } from '@mui/material';
import { FilterList as FilterListIcon } from '@mui/icons-material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';

interface IManagerIconFilterProps {
  tooltipTitle: string;
  isActive: boolean;
  renderContent: (closeMenu: () => void) => React.ReactNode;
}

export const IconFilter: React.FC<IManagerIconFilterProps> = ({
  tooltipTitle,
  isActive,
  renderContent,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <IconButton
          size="small"
          onClick={handleOpen}
          sx={dataFormStyles.filterIcon(isActive)}
        >
          <FilterListIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: dataFormStyles.filterMenuPaper,
          },
        }}
      >
        {renderContent(handleClose)}
      </Menu>
    </>
  );
};

export default IconFilter;

